import apiFactory from '@scoir/api'

export const unauthFallBackUrlFn = () => '/signin'
export default apiFactory(unauthFallBackUrlFn)
